<template>
    <div class="aaPaymentResult">
        <div v-if="init">
            <div class="result">
                <div class="success" v-if="param.result=='Y'">
                    <div class="title">
                        <van-icon name="checked"/>
                        <span class="name">{{item.ticketinfo.status==30?'购买':'提交'}}成功</span>
                    </div>
                    <div class="tip">感谢您的报名。您可以在活动详情-票券查看票券详情</div>
                </div>
                <div class="success" v-if="param.result=='B'">
                    <div class="title">
                        <van-icon name="checked"/>
                        <span class="name">{{item.ticketinfo.status==30?'报名':'提交'}}成功</span>
                    </div>
                    <div class="tip">感谢您的报名。请耐心等待审核，审核通过进行支付。</div>
                </div>
                <div class="fail" v-if="param.result=='N'">
                    <div class="title">
                        <van-icon name="checked"/>
                        <span class="name">购买失败</span>
                    </div>
                    <div class="tip">很抱歉，您的支付失败！</div>
                </div>
            </div>
            <div class="ticket-activity" v-if="param.result!='N'">
                <div class="activity-detail">
                    <div class="title texts-ellipse">{{item.eventinfo.title}}</div>
                    <div class="datatime">{{item.eventinfo.begintime}} - {{item.eventinfo.endtime}}</div>
                    <div class="addr text-ellipse">{{item.eventinfo.address}}</div>
                </div>
                <img :src="dividingLine" alt="" class="dividing-line">
                <div class="ticket-detail">
                    <div class="ticket-summary">
                        <div class="name">{{item.ticketinfo.ticketname}}</div>
                        <div class="value">
                            <span class="num" v-if="item.ticketinfo.seasonticketcount>1">{{item.ticketinfo.ticketcount}}人套票</span>
                            <span class="subtotal">￥{{item.ticketinfo.uprice}} x {{item.ticketinfo.ticketnum}}</span>
                        </div>
                    </div>
                    <div class="status">
                        <span class="title">状态</span>
                        <span :class="cls(item.ticketinfo.status)">{{item.ticketinfo.statusname}}</span>
                    </div>
                </div>
            </div>
            <div class="paymentResult-btn">
                <!--<div class="btn my-ticket" @click="gotoTicket" v-if="param.result!='N'">我的票券</div>-->
                <div class="btn my-ticket" @click="gotoOrderView" v-if="param.result!='N'">查看订单</div>
                <div class="btn my-ticket" @click="gotoActivity" v-if="param.result=='N'">重新购买</div>
                <div class="btn activity-detail" @click="gotoActivity">查看活动详情</div>
            </div>
        </div>
    </div>
</template>

<script>
  import {getAaOrderPayResult} from 'api/activeTools'
  import {mapGetters, mapActions} from 'vuex'
  import {apply, _setClass} from 'api/enumCode'

  export default {
    name: 'aaPaymentResult',
    data() {
      return {
        param: {
          ispaysuccess: this.$route.query.flag ? this.$route.query.flag : '',
          orderno: this.$route.query.orderid ? this.$route.query.orderid : '',
          result: this.$route.query.result ? this.$route.query.result : '',
          rid: this.$route.query.rid ? this.$route.query.rid : '',
          sign: this.$route.query.sign ? this.$route.query.sign : ''
        },
        item: {
          eventinfo: {
            address: '',
            begintime: '',
            coveratturlid: '',
            endtime: '',
            eventid: '',
            title: ''
          },
          ticketinfo: {
            status: null,
            statusname: '',
            ticketname: '',
            ticketnum: 0,
            totalticketcount: 0,
            uprice: ''
          }
        },
        init: false,
        dividingLine: require('@/common/images/activeTools/dividing_line@2x.png')
      }
    },
    mounted() {
      document.title = '报名结果'
      this.setIsInit(false)
      // if (!this.isInit) {
      //     this._initPayResult()
      // }
      this._initPayResult()
    },
    activated() {
      if (this.isInit) {
        this.item.orderno = ''
        this._initPayResult()
      }
    },
    methods: {
      gotoTicket() {
        this.$router.push({name: 'myTicket', query: {eventid: this.item.eventinfo.eventid}})
      },
      gotoOrderView() {
        this.setRefresh(true)
        this.$router.push({name: 'MOrderList'})
      },
      gotoActivity() {
        this.$router.push({name: 'ActivityDetail', query: {eventid: this.item.eventinfo.eventid}})
      },
      _initPayResult() {
        this.param = {
          ispaysuccess: this.$route.query.flag ? this.$route.query.flag : '',
          orderno: this.$route.query.orderid ? this.$route.query.orderid : '',
          result: this.$route.query.result ? this.$route.query.result : '',
          rid: this.$route.query.rid ? this.$route.query.rid : '',
          sign: this.$route.query.sign ? this.$route.query.sign : ''
        }
        if (this.param.result !== 'N') {
          this._getPayResult()
        }
      },
      _getPayResult() {
        this.setLoading(true)
        getAaOrderPayResult({
          data: this.param,
          success: data => {
            this.item = data.data
            this.setLoading(false)
            this.init = true
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      ...mapActions([
        'setLoading',
        'setIsInit',
        'setRefresh'
      ])
    },
    filters: {},
    watch: {},
    computed: {
      cls() {
        return function (value) {
          return _setClass(value, apply.ticketStatus)
        }
      },
      ...mapGetters([
        'isInit'
      ])
    },
    components: {}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/mixin";

    .aaPaymentResult {
        .result {
            font-size: 0.36rem;
            padding: 1rem 0 0.8rem 0;
            text-align: center;
            .title {
                display: flex;
                align-items: center;
                justify-content: center;
                .name {
                    font-weight: 600;
                    color: #333333;
                }
                .van-icon {
                    font-size: 0.5rem;
                    margin-right: 0.18rem;
                }
            }
            .tip {
                color: #666666;
                font-size: 0.24rem;
                margin-top: 0.4rem;
            }
            .success {
                .van-icon {
                    color: #0ABF53;
                }
            }
            .fail {
                .van-icon {
                    color: #FF4747;
                }
            }
        }
        .ticket-activity {
            margin: 0 0.6rem;
            .activity-detail {
                box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
                padding: 0.4rem 0.28rem 0.32rem 0.18rem;
                background: #fff;
                border-radius: 0.1rem 0.1rem 0 0;
                .title {
                    font-size: 0.28rem;
                    line-height: 0.32rem;
                    color: #303133;
                    margin-bottom: 0.2rem;
                    font-weight: 600;
                }
                .datatime, .addr {
                    color: #666666;
                    font-size: 0.24rem;
                    line-height: 0.28rem;
                    margin-top: 0.12rem;
                }
            }
            .dividing-line {
                width: 6.3rem;
                height: 0.28rem;
                display: block;
            }
            .ticket-detail {
                box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
                padding: 0.46rem 0.28rem 0.6rem 0.28rem;
                background: #fff;
                border-radius: 0 0 0.1rem 0.1rem;
                .ticket-summary {
                    color: #333333;
                    font-size: 0.3rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .value {
                        .num {
                            font-size: 0.2rem;
                            color: #999999;
                            margin-right: 0.32rem;
                        }
                        .subtotal {
                        }
                    }
                }
                .status {
                    margin-top: 0.6rem;
                    color: #333333;
                    font-size: 0.3rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .orange {
                        color: #FFA904;
                    }
                }
            }

        }
        .paymentResult-btn {
            margin: 0.9rem 0.6rem 0 0.6rem;
            font-size: 0.3rem;
            .btn {
                height: 0.76rem;
                width: 6.3rem;
                text-align: center;
                line-height: 0.76rem;
                border-radius: 0.4rem;
                box-sizing: border-box;
            }
            .my-ticket {
                color: #fff;
                background: linear-gradient(360deg, rgba(10, 191, 83, 1) 0%, rgba(71, 236, 201, 1) 100%);
            }
            .activity-detail {
                margin-top: 0.32rem;
                border: 1px solid #E5E5E5;
                background: #fff;
            }
        }
        .tc-orange {
            color: #FFA904;
        }
        .tc-red {
            color: #FF4747;
        }
        .tc-green {
            color: #0ABF53;
        }
    }
</style>
